// Core
import { Link, Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';

// Chakra imports
import { 
  Box, 
  Flex, 
  Text,
  useColorModeValue
} from '@chakra-ui/react';

// Components
import LikedMeList from './LikedMe.js';

function LikedMe(props) {
  const { path, url } = useRouteMatch();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  const textColor = useColorModeValue('blue.800', 'white');

  return (
    <>
      <Box p="105px 15px 130px 15px" maxH="calc(100vh - 0px)" overflowY="auto" position="relative">
        <Box align='left' mt='18px'>
          <Switch>
            <Route path={`${path}`} render={() => <LikedMeList object={props.object} />} />
            <Redirect from={`${path}*`} to={`${path}`} />
          </Switch>
        </Box>
      </Box>
    </>
  );
}

export default LikedMe;